export const otaConnectWizard = {
  google: {
    lead: "Prima controlliamo che la scheda del tuo alloggio sia completa: Google non ha un pannello e mostra solo ciò che gli inviamo.",
    goConnect: "Continua su Channex",
    nextIsChannex: "L'ultimo passo — scegliere quali camere e tariffe vede Google — si fa nella schermata di Channex, che si aprirà ora.",
    typeLabel: "Che tipo di alloggio è?",
    hotel: "Hotel",
    hotelHint: "Con più camere",
    vr: "Casa vacanze",
    vrHint: "Una casa o un appartamento intero",
    checking: "Controllo della scheda…",
    ready: "Tutto pronto: Google può pubblicarlo.",
    missing: "Manca 1 cosa prima di collegare | Mancano {count} cose prima di collegare",
    canFix: "Una parte ce l'abbiamo già e possiamo caricarla noi.",
    prepare: "Prepara la scheda",
    prepareFailed: "Impossibile preparare la scheda.",
    checkFailed: "Impossibile controllare la scheda.",
    cancelLabel: "Politica di cancellazione",
    cancelFree: "Cancellazione gratuita",
    cancelNon: "Non rimborsabile",
    bedrooms: "Camere da letto",
    beds: "Letti",
    bathrooms: "Bagni",
  },
  common: {
    close: "Chiudi",
  },
  intro: {
    imageAlt: "Prima di collegare Booking, tieni presente questo",
    continue: "Ho capito, continua",
  },
  header: {
    edit: "Modifica",
    connect: "Connetti",
    guidedStep: "Configurazione guidata · passaggio {current} di {total}",
  },
  steps: {
    connection: "Connessione",
    rooms: "Camere",
    rates: "Tariffe",
    review: "Revisione",
    done: "Fatto",
  },
  fields: {
    hotel_id: { label: "ID hotel", hint: "Lo trovi nell'extranet dell'OTA, in alto a destra." },
    hotel_code: { label: "Codice hotel", hint: "L'identificativo della tua struttura sull'OTA." },
    property_id: { label: "ID struttura", hint: "" },
    listing_id: { label: "ID annuncio", hint: "" },
    property_code: { label: "Codice struttura", hint: "" },
    username: { label: "Nome utente", hint: "Il tuo nome utente per accedere all'extranet dell'OTA." },
    user: { label: "Nome utente", hint: "Il tuo nome utente per accedere all'extranet dell'OTA." },
    password: { label: "Password", hint: "La password del tuo extranet OTA." },
    api_key: { label: "Chiave API", hint: "Ti viene fornita dall'OTA." },
    agent_id: { label: "ID agente", hint: "" },
  },
  step0: {
    lead: "Incolla l'identificativo della tua struttura sul canale. Lo verificheremo all'istante.",
    loadingChannel: "Caricamento dei requisiti del canale…",
    notAvailable: "Questo canale non è ancora disponibile tramite API guidata.",
    oauthText: "{name} si collega al tuo account tramite accesso sicuro. Quando fai clic, apriamo {name} in un'altra scheda per autorizzare; una volta tornato, la connessione comparirà nei tuoi canali.",
    oauthConnect: "Connetti con {name}",
    oauthOpened: "Abbiamo aperto {name} in un'altra scheda. Autorizza lì e la connessione comparirà nei tuoi canali.",
    currencyLabel: "Valuta",
    currencyTooltip: "Viene impostata dal canale per la tua struttura. Si compila automaticamente quando verifichi la connessione; non è modificabile.",
    currencyPlaceholder: "Si compila alla verifica",
    currencyDetected: "Rilevata automaticamente",
    currencyVerifyToDetect: "Verifica la connessione per rilevarla",
    verified: "Verificata",
    testConnection: "Verifica connessione",
    testOk: "Connessione verificata. Continua per abbinare camere e tariffe.",
    testFailedDefault: "Non è stato possibile verificare la connessione. Controlla l'identificativo.",
  },
  step1: {
    leadAirbnb: "Abbina ogni annuncio Airbnb a una delle tue unità.",
    leadOther: "Abbina ogni camera di {channel} a un'unità del tuo annuncio.",
    listingChip: "Annuncio: {name}",
    noLimitChip: "Nessun limite di account o strutture",
    loadingRooms: "Caricamento delle camere del canale…",
    noRooms: "Nessuna camera da mappare trovata.",
    dupUnitWarning: "«{unit}» è assegnata a più di una camera di {channel}. Ogni camera del canale deve corrispondere a una camera diversa tra le tue: se salvi così, {channel} le venderebbe tutte allo stesso prezzo. Correggi qui sotto prima di continuare.",
    searchPlaceholder: "Cerca…",
    noRoomMatch: "Nessuna camera corrisponde a «{query}».",
    copied: "Copiato",
    copyId: "Copia ID: {id}",
    rateCountMeta: "{channel} · {count} tariffa/e",
    edit: "Modifica",
    disconnect: "Disconnetti",
    unitSearchPlaceholder: "Cerca la tua unità o il tuo annuncio…",
    noMatch: "Nessuna corrispondenza",
    cancel: "Annulla",
  },
  step2: {
    lead: "La tariffa principale di ogni camera si compila automaticamente dalla tua tariffa {channel}. Se una camera ha più tariffe, imposta quanto in più (o in meno) in % applicherai a ciascuna.",
    crossedFixed: "Una tariffa è stata abbinata a un'altra camera, il che farebbe vendere {channel} al prezzo sbagliato. La tariffa propria di ogni camera è stata ripristinata: rivedile prima di continuare. | {count} tariffe sono state abbinate a un'altra camera, il che farebbe vendere {channel} al prezzo sbagliato. La tariffa propria di ogni camera è stata ripristinata: rivedile prima di continuare.",
    noRates: "Nessuna tariffa da mappare trovata.",
    yourPct: "La tua % per questa camera",
    auto: "Automatica",
    changePct: "Modifica %",
    multiRateAlert: "Questa camera ha più tariffe. Imposta quale percentuale in più (o in meno) applicherai ai tuoi ospiti su ciascuna se prenotano tramite {channel}.",
    minStayOnApply: "Viene salvato premendo «Applica».",
    minStayMissing: "Nessun soggiorno minimo proprio: {channel} la vende con il minimo della tariffa principale",
    setMinStay: "Imposta soggiorno minimo",
    nights: "{n} notte | {n} notti",
    minNights: "min. {n} notte | min. {n} notti",
    minInherited: "min. della tariffa principale",
    ownPlanSummary: "prezzo e minimo propri",
    minStayNotDerived: "Il soggiorno minimo di {nights} non è stato impostato: «{rate}» è una tariffa principale e usa il proprio soggiorno minimo. Perché {channel} richieda {nights} su questa tariffa, applica una % invece di sceglierla.",
  },
  step3: {
    lead: "Questo è ciò che collegheremo su {channel}. Rivedilo e fai clic su Connetti.",
    channelCurrency: "Valuta del canale:",
    chargesNote: "Il check-in/out e gli addebiti (pulizie, ecc.) vengono presi dalle impostazioni della tua struttura.",
  },
  done: {
    titleConnected: "{name} collegato!",
    titleUpdated: "{name} aggiornato!",
    subActive: "Il canale è attivo: stiamo già sincronizzando prezzi e disponibilità.",
    subPaused: "Il canale è collegato ma in pausa. Attivalo per iniziare a sincronizzare prezzi e disponibilità.",
    subUpdated: "La mappatura del canale è stata aggiornata con successo.",
    notificationSent: "Notifica inviata",
    syncing: "Sincronizzazione…",
    paused: "In pausa",
    activateTitle: "Attiva canale",
    activateDesc: "Inizia a inviare prezzi e disponibilità a {channel}.",
    activateBtn: "Attiva canale",
    activated: "Attivato",
    loadReservationsTitle: "Importa le prenotazioni future",
    loadReservationsDesc: "Porta in WACheckin le prenotazioni che hai già su {channel}.",
    imported: "Importate",
    extract: "Importa",
  },
  rates: {
    mainRate: "Tariffa principale",
    standardRate: "Tariffa Standard",
  },
  rooms: {
    listingFallback: "Annuncio {id}",
    unitFallback: "unità",
  },
  buttons: {
    back: "Indietro",
    saveChanges: "Salva modifiche",
    connect: "Connetti",
    finish: "Fine",
    continue: "Continua",
  },
  errors: {
    dupUnit: "L'unità «{unit}» è assegnata a più di una camera di {channel}. Ogni camera deve corrispondere a un'unità diversa.",
    crossedBlocked: "C'è una tariffa abbinata a un'altra camera ({list}). Torna al passaggio delle tariffe e scegli la tariffa propria di ogni camera: se salvi così, {channel} venderebbe al prezzo sbagliato. | Ci sono {count} tariffe abbinate a un'altra camera ({list}). Torna al passaggio delle tariffe e scegli la tariffa propria di ogni camera: se salvi così, {channel} venderebbe al prezzo sbagliato.",
    dupRate: "La tariffa «{rate}» è abbinata a più di una camera di {channel} ({rooms}). Ogni camera deve avere la propria tariffa: se salvi così, verrebbero vendute allo stesso prezzo.",
    roomJoiner: " e ",
    dupRateFallback: "una tariffa",
    dupUnitFallback: "questa unità",
    needRate: "Abbina almeno una tariffa prima di connettere.",
    updateFailed: "Impossibile aggiornare la connessione.",
    createFailed: "Impossibile creare la connessione.",
    unmapFailed: "Impossibile disconnettere l'annuncio.",
    needAirbnbMap: "Abbina almeno un annuncio a un'unità.",
    unitNoChannexRate: "L'unità \"{unit}\" non ha alcuna tariffa con un id Channex.",
    airbnbSaveFailed: "Impossibile salvare le mappature Airbnb.",
    actionFailed: "Impossibile eseguire l'azione.",
    oauthLinkFailed: "Impossibile generare il link di connessione.",
    testFailed: "Errore durante la verifica della connessione.",
    testNoVerify: "Questo canale non richiede una verifica preventiva.",
    rateCreateFailedNeedStandard: "Impossibile creare la tariffa. Verifica che l'unità abbia una Tariffa Standard.",
    rateCreateFailed: "Impossibile creare la tariffa.",
    minStaySaveFailed: "«{rate}» è stata scelta, ma non è stato possibile salvare il suo soggiorno minimo di {nights}: resta quello che aveva.",
  },
};
